module.exports = __webpack_public_path__ + "static/media/no-course.24a28ef7.svg";